import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { defineMessages } from 'react-intl';
import { Field } from 'redux-form';

import Message from 'components/Message';
import { PASSWORD_UPDATE_FORM_NAME } from 'constants/logic';
import { Card, CardTitle } from 'components/Card';
import { Form, Input, Button, withForm } from 'components/Form';
import { bem } from 'helpers/class-name';

import './PasswordFormSection.scss';

const { element } = bem('password-form-section');

const messages = defineMessages({
  changePW: {
    id: 'settings.password-form-section.change-pw',
    defaultMessage: 'Change password',
  },
  placeholderPW: {
    id: 'settings.password-form-section.placeholder-pw',
    defaultMessage: 'Type new password',
  },
  placeholderConfirm: {
    id: 'settings.password-form-section.placeholder-confirm',
    defaultMessage: 'Type it again',
  },
  errorRequired: {
    id: 'settings.password-form-section.error-required',
    defaultMessage: 'Password required',
  },
  errorShort: {
    id: 'settings.password-form-section.error-short',
    defaultMessage: 'Password can’t be less than 6 symbols',
  },
  errorLong: {
    id: 'settings.password-form-section.error-long',
    defaultMessage: 'Password can’t be more than 25 symbols',
  },
  errorMismatch: {
    id: 'settings.password-form-section.error-mismatch',
    defaultMessage: 'Passwords must match',
  },
});

export const syncValidator = values => {
  const { password, repeatPassword } = values;

  const errors = {};
  if (!password) {
    errors.password = messages.errorRequired;
  } else if (password.length < 6) {
    errors.password = messages.errorShort;
  } else if (password.length > 25) {
    errors.password = messages.errorLong;
  }

  if (password && password !== repeatPassword) {
    errors.repeatPassword = messages.errorMismatch;
  }
  return errors;
};

export const PasswordSection = ({ canSubmit }) => (
  <>
    {
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      <a className={element('anchor')} id="change-password" />
    }
    <Card>
      <Message as={CardTitle} message={messages.changePW} />
      <Form>
        <div className="grid">
          <Field
            className="grid__item sm-1/2"
            name="password"
            type="password"
            placeholder={messages.placeholderPW}
            component={Input}
            autoComplete="new-password"
          />
          <Field
            className="grid__item sm-1/2"
            name="repeatPassword"
            type="password"
            placeholder={messages.placeholderConfirm}
            autoComplete="new-password"
            component={Input}
          />
          <div className="grid__item text--right">
            <Message
              as={Button}
              className="bt--width-lg"
              disabled={!canSubmit}
              type={Button.TYPES.SUBMIT}
              message={messages.changePW}
            />
          </div>
        </div>
      </Form>
    </Card>
  </>
);

PasswordSection.propTypes = {
  canSubmit: PropTypes.bool,
};

const PasswordFormSection = compose(
  withForm({
    name: PASSWORD_UPDATE_FORM_NAME,
    syncValidator,
  })
)(PasswordSection);

export default PasswordFormSection;
